<!-- Responsibility: Display the preforge processing status and logs.
Scope: View-only panel for AI generation progress. -->
<preforge-workspace-processing>
  <section class="preforge-processing-panel" data-preforge-stage="processing">
    <div class="preforge-processing-head">
      <h2>{ props.title }</h2>
      <p class="panel-copy">{ props.copy }</p>
    </div>
    <ul class="preforge-progress-feed">
      <li each={ line in props.lines }>{ line }</li>
    </ul>
  </section>

  <style>
    .preforge-processing-panel {
      padding: var(--space-lg);
      background: var(--bg-deep);
      border: 1px solid var(--border);
      border-radius: 1rem;
      display: grid;
      gap: var(--space-md);
    }
    .preforge-processing-head h2 { margin: 0; color: var(--gold); }
    .preforge-progress-feed {
      list-style: none;
      padding: var(--space-sm);
      margin: 0;
      background: black;
      border-radius: 0.5rem;
      font-family: var(--font-mono, monospace);
      font-size: 0.8rem;
      color: #00ff00;
      max-height: 12.5rem;
      overflow-y: auto;
    }
    .preforge-progress-feed li { padding: 0.125rem 0; border-bottom: 1px solid #003300; }
  </style>
</preforge-workspace-processing>
